import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {HttpClient,HttpHeaders, HttpParams} from '@angular/common/http';
import { AppSettings } from "../config/AppSettings";
import { Tools } from '../modules/tools';
import {GridPage} from '../util/components/gridtable/gridtable.component';

@Injectable({
  providedIn: 'root'
})
export class TariffRuleService {

  constructor(private http: HttpClient, private appsetting: AppSettings,private tools: Tools) {}

  saveTariffRule(body,requestType:string) {
   /* if(requestType==="bulk"){
    let header = new HttpHeaders();
    return this.http.post( this.appsetting.get("server-url") + '/api/rfidbulk',body,
    {headers : header,observe : "body", responseType : "json"})
      .map(res => res);
    }else{*/
    let header = new HttpHeaders();
    return this.http.post( this.appsetting.get("server-url") + '/api/addupdatetariffrule',body,
    {headers : header,observe : "body", responseType : "json"})
      .map(res => res);
    
  }
  getTariffRule(Id: number) {
    let header = new HttpHeaders();
    let param: HttpParams = new HttpParams();
    param = param.append("Id", Id.toString());
    return this.http
      .get(this.appsetting.get("server-url") + "/api/tariffrule", {
        headers: header,
        observe: "body",
        params: param,
        responseType: "json"
      })
      .map(res => res);
  }

getTariffRuleList(searchField) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
  //  httpParam=httpParam.append("page", pageinfo.number.toString());
  //  httpParam=httpParam.append("size",pageinfo.size.toString());
   //httpParam=httpParam.append("status",searchField.status);
  // httpParam=httpParam.append("startdate", this.tools.formatDateToDDMMMYY(searchField.startdate));
  //  httpParam=httpParam.append("enddate",this.tools.formatDateToDDMMMYY(searchField.enddate));    
    //  httpParam = httpParam.append("username", searchField.searchText);
      httpParam = httpParam.append("scope", searchField.scope);
      httpParam=httpParam.append("status",searchField.status);
      return this.http.get( this.appsetting.get("server-url") + '/api/tariffrulelist',{headers : header, observe : "body", params : httpParam,responseType : "json"})
    .map(res=>res);
  }
 
  getAllSubscription() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
  //  httpParam=httpParam.append("page", pageinfo.number.toString());
  //  httpParam=httpParam.append("size",pageinfo.size.toString());
   //httpParam=httpParam.append("status",searchField.status);
  // httpParam=httpParam.append("startdate", this.tools.formatDateToDDMMMYY(searchField.startdate));
  //  httpParam=httpParam.append("enddate",this.tools.formatDateToDDMMMYY(searchField.enddate));    
    //  httpParam = httpParam.append("username", searchField.searchText);
      return this.http.get( this.appsetting.get("server-url") + '/api/allSubscription',{headers : header, observe : "body", params : httpParam,responseType : "json"})
    .map(res=>res);
  }
  getAllTariffs(scope:String) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
   httpParam=httpParam.append("scope", scope.toString());
  //  httpParam=httpParam.append("size",pageinfo.size.toString());
   //httpParam=httpParam.append("status",searchField.status);
  // httpParam=httpParam.append("startdate", this.tools.formatDateToDDMMMYY(searchField.startdate));
  //  httpParam=httpParam.append("enddate",this.tools.formatDateToDDMMMYY(searchField.enddate));    
    //  httpParam = httpParam.append("username", searchField.searchText);
      return this.http.get( this.appsetting.get("server-url") + '/api/alltariffrules',{headers : header, observe : "body", params : httpParam,responseType : "json"})
    .map(res=>res);
  }
/*deleteRFID(bookingId: number) {
    let header = new HttpHeaders();
    let param: HttpParams = new HttpParams();
    param = param.append("bookingId", bookingId.toString());
    return this.http
      .get(this.appsetting.get("server-url") + "/api/changebookingstatus", {
        headers: header,
        observe: "body",
        params: param,
        responseType: "json"
      })
      .map(res => res);
  }*/
}